export const SELECTION_COLOR_SAMPLE_SOURCE_ID = "selection-color-sample-tool";
